export default __webpack_public_path__ + "static/media/img3.13a18c57.jpg";